<app-header [title]="'Component Credentials'">
  <app-button
    *ngIf="canManageCredentials"
    [black]="true"
    [title]="'+ Create Credential'"
    (click)="navigateToCreateCredential()"
    header-button
  ></app-button>
</app-header>

<div class="toolbar">
  <div class="search-field">
    <app-input
      [placeholder]="'Search component credentials'"
      (inputValue)="onSearchChange($event)"
    ></app-input>
  </div>
  <div class="result-count" *ngIf="!componentCredentialsStore.loading()">
    {{ filteredCredentials.length }} credential{{
      filteredCredentials.length === 1 ? '' : 's'
    }}
  </div>
</div>

<div class="status-card" *ngIf="componentCredentialsStore.loading()">
  Loading component credentials...
</div>

<div
  class="status-card"
  *ngIf="
    !componentCredentialsStore.loading() && filteredCredentials.length === 0
  "
>
  No component credentials found.
</div>

<div
  class="list"
  *ngIf="!componentCredentialsStore.loading() && filteredCredentials.length > 0"
>
  <article
    class="credential-card"
    *ngFor="let credential of filteredCredentials; trackBy: trackByCredential"
  >
    <div class="card-head">
      <div class="title-block">
        <h3>{{ getComponentName(credential.component) }}</h3>
        <span class="credential-id" *ngIf="credential.id">
          ID: {{ credential.id }}
        </span>
      </div>

      <div class="actions" *ngIf="canManageCredentials">
        <button
          class="icon-action-btn edit-btn"
          type="button"
          aria-label="Edit component credential"
          (click)="navigateToEditCredential(credential.id || '')"
          [disabled]="!credential.id"
        >
          <mat-icon class="outlined-icon">edit</mat-icon>
        </button>

        <button
          class="icon-action-btn validate-btn"
          type="button"
          aria-label="Validate component credential"
          matTooltip="Validate credential"
          matTooltipPosition="above"
          (click)="validateCredential(credential.id || '')"
          [disabled]="!credential.id"
        >
          <mat-icon class="outlined-icon">science</mat-icon>
        </button>

        <button
          class="icon-action-btn delete-btn"
          type="button"
          aria-label="Delete component credential"
          (click)="deleteCredential(credential.id || '')"
          [disabled]="!credential.id"
        >
          <mat-icon class="outlined-icon">delete</mat-icon>
        </button>
      </div>
    </div>

    <div class="chip-list" *ngIf="credential.scope?.name">
      <span class="scope-chip">{{ credential.scope?.name }}</span>
    </div>

    <p
      class="description"
      [matTooltip]="credential.description || ''"
      [matTooltipDisabled]="
        !(credential.description && credential.description.length > 100)
      "
      matTooltipPosition="above"
    >
      {{ credential.description || 'No description provided.' }}
    </p>

    <div class="meta">
      <div>
        <strong>Client ID:</strong> {{ credential.clientInfo?.clientId || '-' }}
      </div>
    </div>
  </article>
</div>
